<template>
    <div class="user-status-calendar-pie-chart">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/calendar";
import { BarChart, PieChart, ScatterChart, CustomChart } from "echarts/charts";
import log2 from "../../../../../../utils/log2";
import { i18n } from "../../../../../../language";
import moment from "moment";

echarts.use([BarChart]);
echarts.use([ScatterChart]);
echarts.use([PieChart]);
echarts.use([CustomChart]);

Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=calendar-pie

const log = log2("UserStatusCalendarPieChart");
export default Vue.extend({
    name: "UserStatusCalendarPieChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Chart Title",
        },
        subTitle: {
            type: String,
            default: "",
        },
        startDate: {
            type: String,
        },
        endDate: {
            type: String,
        },
        pieSeries: {
            type: Array,
            default: () => [],
        },
        scatterData: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getOptions() {
            const cellSize = [80, 80];
            const pieRadius = 30;
            let ranges = [];
            if (moment(this.startDate).isSame(this.endDate, "month")) {
                ranges = [moment(this.startDate).format("YYYY-MM")];
            } else {
                ranges = [moment(this.startDate).format("YYYY-MM"), moment(this.endDate).format("YYYY-MM")];
            }
            const options = {
                color: [
                    "rgb(27, 197, 189)",
                    "rgb(54, 153, 255)",
                    "rgb(255, 168, 0)",
                    "rgb(246, 78, 96)",
                    "rgb(131,131,131)",
                ],
                tooltip: {},
                legend: {
                    data: ["Online", "Away", "Busy", "Offline", "Disconnected"],
                    bottom: 10,
                },
                title: [
                    {
                        text: this.title,
                        subtext: this.subTitle,
                        textAlign: "center",
                        left: "50%",
                    },
                ],
                grid: {
                    top: 100,
                    width: "100%",
                    height: "auto",
                    left: 200,
                    containLabel: true,
                },
                toolbox: {
                    show: true,
                    feature: {
                        dataZoom: {
                            yAxisIndex: "none",
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ["line", "bar"] },
                        restore: {},
                        saveAsImage: {},
                    },
                },
                calendar: {
                    top: "middle",
                    left: "center",
                    orient: "vertical",
                    cellSize: cellSize,
                    yearLabel: {
                        show: false,
                        fontSize: 30,
                    },
                    dayLabel: {
                        margin: 20,
                        firstDay: 1,
                        nameMap: [
                            i18n.t("message.sunday"),
                            i18n.t("message.monday"),
                            i18n.t("message.tuesday"),
                            i18n.t("message.wednesday"),
                            i18n.t("message.thursday"),
                            i18n.t("message.friday"),
                            i18n.t("message.saturday"),
                        ],
                    },
                    monthLabel: {
                        show: false,
                    },
                    range: ranges,
                },
                series: [
                    {
                        id: "label",
                        type: "scatter",
                        coordinateSystem: "calendar",
                        symbolSize: 0,
                        label: {
                            normal: {
                                show: true,
                                formatter: function (params) {
                                    return echarts.format.formatTime("dd", params.value[0]);
                                },
                                offset: [-cellSize[0] / 2 + 10, -cellSize[1] / 2 + 10],
                                textStyle: {
                                    color: false ? "white" : "black",
                                    fontSize: 14,
                                },
                            },
                        },
                        data: this.scatterData,
                    },
                    ...this.pieSeries,
                ],
            };
            log("options", options);
            return options;
        },
    },
});
</script>

<style scoped lang="scss">
.user-status-calendar-pie-chart {
    width: 100%;
    height: 600px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
